import React from "react";
import {
    Box,
    FormControl,
    styled,
    TextField,
    Autocomplete
} from "@mui/material";
import STIntervalResultComponent from "../../../api/StationaryTesting/STIntervalResultOption";
import STIntervalResultForm from "./STIntervalResultForm";
import { getMessage } from "../../../global";
import ModalSimpleButton from '../../../components/Modal/ModalSimpleButton';
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";
import { GlobalButton, GlobalSecondaryButton } from "../../styles";

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    marginBottom: "20px"
}));

const StyledFormControl = styled(FormControl)(() => ({
    display: 'flex',
    width: "50rem"
}));

const StyledDiv = styled('div')({
    display: 'flex',
    justifyContent: "space-between"
});

const STIntervalResult = (props) => {

    const initialStateIntervalResult = {
        id: undefined,
        optionName: "",
        isActive: false,
    };

    const validationsInitialState =
    {
        optionName: "",
    };

    const [isAdd, setIsAdd] = React.useState(false);
    const [infoData, setInfoData] = React.useState(initialStateIntervalResult);
    const [intervalResultList, setIntervalResultList] = React.useState(null);
    const [invalidField, setInvalidField] = React.useState(validationsInitialState);

    const [modalSimpleButton, setModalSimpleButton] = React.useState(false);
    const [modalSimpleButtonText, setModalSimpleButtonText] = React.useState('');
    const [modalSimpleTitle, setModalSimpleTitle] = React.useState('');
    const [modalSimpleText, setModalSimpleText] = React.useState('');

    const { hasAnyRole } = useAuth();
    const canEdit = hasAnyRole([Roles.StationaryTestingSME, Roles.Developer]);

    function closeModalSimpleButton() {
        setModalSimpleButton(false);
    }

    function openModalSimpleButton(title, text, buttonText) {
        setModalSimpleButtonText(buttonText)
        setModalSimpleButton(true);
        setModalSimpleTitle(title);
        setModalSimpleText(text);
    }

    function handleSubmit(event) {
        event.preventDefault();

        if (!validateFields()) {
            if (infoData.id !== undefined)
                saveIntervalResult();
            else {

                STIntervalResultComponent.get(infoData.optionName).then((intervalResultExists) => {
                    if ((intervalResultExists !== undefined && intervalResultExists !== null))
                        openModalSimpleButton('Fail', 'This Interval Result name already exist', 'Ok');
                    else saveIntervalResult();
                });
            }
        }
    }

    function saveIntervalResult() {

        let intervalResult = new STIntervalResultComponent({
            optionName: infoData.optionName,
            isActive: infoData.isActive
        });

        if (infoData.id === undefined) {
            STIntervalResultComponent.add(intervalResult).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Interval Result Option saved with success', 'Ok');
                    loadIntervalResultFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        } else {
            STIntervalResultComponent.update(intervalResult).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Interval Result Option updated with success', 'Ok');
                    loadIntervalResultFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        }
    }

    function handleChangeIsAdd() {
        setIsAdd(true);
        resetForm();
    }


    function loadIntervalResultFilter() {
        STIntervalResultComponent.getAll().then((res) => {
            if (res.length > 0) {

                let array = [];
                array.push({ id: undefined, optionName: "" });
                array.push(...res);

                setIntervalResultList(array);
            }
        });
    }

    function validateFields() {
        let requiredIntervalResultName = infoData.optionName === "" ? getMessage('REQUIRED_FIELD') : "";

        setInvalidField({
            ...invalidField,
            optionName: requiredIntervalResultName
        });

        return ((requiredIntervalResultName !== ""));
    }

    function resetForm() {

        setInfoData(initialStateIntervalResult);
        setInvalidField(validationsInitialState);
    }

    function handleChangeSTIntervalResultFilter(idSelected) {
        setInfoData(initialStateIntervalResult);

        setInfoData(() => ({
            ...initialStateIntervalResult,
            id: idSelected,
            optionName: idSelected
        }));

        setIsAdd(true);

        setInvalidField(validationsInitialState);

        if (idSelected !== "") {
            STIntervalResultComponent.get(idSelected).then((intervalResult) => {
                if (intervalResult !== null) {

                    setInfoData(() => ({
                        ...infoData,
                        id: idSelected,
                        optionName: intervalResult.optionName,
                        isActive: intervalResult.isActive,
                    }));
                }
            });
        }
    }

    React.useMemo(() => {
        if (intervalResultList === null) {
            loadIntervalResultFilter();
        }
    }, [intervalResultList])

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <StyledDiv>
                    <div>
                        <StyledBox>
                            <StyledFormControl sx={{ m: 1, width: "35rem" }} variant='outlined'>

                                <StyledBox sx={{ justifyContent: "space-between" }}>
                                    <Autocomplete
                                        noOptionsText={"Loading Interval Result Option..."}
                                        value={infoData.optionName === '' ? null : infoData.optionName}
                                        onChange={(e, value) => {
                                            handleChangeSTIntervalResultFilter(value);
                                        }}
                                        disablePortal
                                        options={intervalResultList ? intervalResultList.map((intervalResult) => intervalResult.optionName) : []}
                                        sx={{ width: "35rem" }}
                                        renderInput={(params) => <TextField {...params} variant="outlined" size="small" margin="none" label="Interval Result Option" />}
                                        autoSelect
                                    />

                                    <GlobalSecondaryButton sx={{ width: "8rem", marginLeft:"1rem" }}
                                        variant='contained'
                                        type="button"
                                        onClick={handleChangeIsAdd}
                                    >Add New</GlobalSecondaryButton>

                                </StyledBox>

                            </StyledFormControl>

                        </StyledBox>

                        {isAdd === true && <STIntervalResultForm
                            infoData={infoData} setInfoData={setInfoData}
                            invalidField={invalidField}
                            handleChangeSTIntervalResultFilter={handleChangeSTIntervalResultFilter}
                            canEdit={canEdit}
                        >
                        </STIntervalResultForm>}

                        {
                            isAdd === true &&
                            <div>
                                <StyledBox sx={{ mb: 1, mt: 2, justifyContent: "space-between" }}>
                                    <GlobalButton sx={{ width: "8rem" }}
                                        variant='contained'
                                        type="submit"
                                        disabled={!canEdit}>Save</GlobalButton>
                                </StyledBox>
                            </div>
                        }

                    </div>

                </StyledDiv>

            </form >

            <ModalSimpleButton title={modalSimpleTitle} buttonText={modalSimpleButtonText} buttonAction={closeModalSimpleButton} open={modalSimpleButton} setOpen={setModalSimpleButton}>
                <label>
                    {modalSimpleText}
                </label>
            </ModalSimpleButton>

        </div >
    )
}

export default STIntervalResult;